/* tslint:disable */
/* eslint-disable */
/**
 * Cushla API
 * REST API for Cushla
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Type of error that may require different type of handling (logging, showing translated message, etc.).
 * @export
 * @enum {string}
 */

export enum CushlaErrorCodeType {
  INTERNAL = 'INTERNAL',
  CUSTOMER = 'CUSTOMER',
}
